
export default defineNuxtPlugin(async () => {

    const { LRUCache } = await import("lru-cache");

    // Configure the LRU cache
    const lruCache = new LRUCache({
        max: 500, // Maximum items the cache can hold
        ttl: 1000 * 60 * 10, // Time-to-live (10 minutes)
    });

    // Provide the cache globally
    return {
        provide: {
            lruCache,
        },
    };
});